import { Resource } from '../i18n';

export const it: Resource = {
  cart: {
    summary: {
      coupons: {
        title: 'Inserisci un codice sconto',
      },
    },
  },
  checkout: {
    step: {
      billingAddress: {
        title: 'Indirizzo di fatturazione',
    }
  }},
  form: {
    addressForm: {
      copyToBilling: {
        label: 'Imposta anche come indirizzo di fatturazione',
      }
    },
    newsletterForm: {
      buttons: {
        submit: {
          label: 'Iscriviti'
        }
      }
    },
  
  },
  misc: {
    product: {
      color: 'Colore',
      shippingDescription: 'Spedizione stimata entro {{shippingDescription}}',
      size: 'Taglia'
    },
    storeName: 'Yes Zee'
  },
  product: {
    relatedProduct: {
      title: 'Potrebbe piacerti anche'
    },
    selectSize: 'Seleziona una taglia',
    size: 'Taglia'
  },
  welcome: 'Benvenuto su store-essenza!'
};
